export default "__VITE_ASSET__BxvNd8f9__"